import 'shared/global';
import 'components/social/SocialShare';
import 'components/subnav';

$(document).ready(function () {
    $('.js-facebook-share').on('click', function () {
        setTrackSocialClick('facebook');
    });
    $('.js-twitter-share').on('click', function () {
        setTrackSocialClick('twitter');
    });
    $('.js-link-share').on('click', function () {
        setTrackSocialClick('copy');
    });

    var url = $(location).attr('href');
    var segments = url.split('/');

    if (url.includes('/recommended/')) {
        var currentPhoto = segments[7];
    } else {
        var currentPhoto = segments[8];
    }

    if (currentPhoto && !currentPhoto.includes('?')) {
        $(document).scrollTop($('#photo' + currentPhoto).position().top);
    }
    $(document).on('scroll', throttle(onScroll, 800));
});

var currentUrl = '';

function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
}

function onScroll(event) {
    var scrollPos = $(document).scrollTop() + 175;

    $('article').each(function () {
        var photo_id = $(this).attr('id');
        var refElement = $('#' + photo_id);
        var photoNumberTotal = $('.grid-view-container').attr('data-total');

        if (
            refElement.position().top <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            if (currentUrl != $(this).attr('data-item-position-url')) {
                history.pushState(null, null, $(this).attr('data-item-position-url'));
                currentUrl = $(this).attr('data-item-position-url');
                var photoName = $(this).children('img').attr('alt');
                var photoId = $(this).children('img').attr('id');
                var photoNumber = photo_id.substr(5);
                var photoNumberPercentViewed = (photoNumber / photoNumberTotal).toFixed(2);

                CBS.Promises.Tracking.onLoad(function () {
                    if (typeof om != 'undefined') {
                        om.trackState({
                            pageType: 'photos_individual',
                            photoName: photoName,
                            photoId: photoId,
                            photoNumber: photoNumber,
                            photoNumberTotal: photoNumberTotal,
                            photoNumberPercentViewed: photoNumberPercentViewed,
                        });
                    }
                });
            }
        }
    });
}

$('.social__container').SocialShare();

function setTrackSocialClick(type) {
    CBS.Promises.Tracking.onLoad(function () {
        if (typeof om != 'undefined') {
            om.trackSocialClick({
                socialService: type,
            });
        }
    });
}
